import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { getEmbeddedDashboardUrl } from '../../../../utils/engagement';
import {
  Container,
  TitleContainer,
  Title,
  BetaTag,
  TagContainer,
  Iframe,
} from './EngagementPage.styled';

const iframeName = `metabase-iframe`;

const EngagementPage = ({ spaceId, userId, sessionToken }) => {
  const [engagementUrl, setEngagementUrl] = useState('');

  const fetchEngagementDashboardUrl = useCallback(
    getEmbeddedDashboardUrl({
      spaceId,
      userId,
      sessionToken,
    }),
    [spaceId]
  );

  useEffect(() => {
    fetchEngagementDashboardUrl().then(setEngagementUrl);
  }, [fetchEngagementDashboardUrl]);

  return (
    <Container>
      <TitleContainer>
        <Title>Engagement insights</Title>
        <TagContainer>
          <BetaTag>BETA</BetaTag>
        </TagContainer>
      </TitleContainer>
      <Iframe
        title="metabase"
        src={engagementUrl}
        name={iframeName}
        frameBorder="0"
        data-testid={iframeName}
      >
        Loading...
      </Iframe>
    </Container>
  );
};

EngagementPage.propTypes = {
  spaceId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  sessionToken: PropTypes.string.isRequired,
};

export default React.memo(EngagementPage);
